module.exports = __webpack_public_path__ + "img/send-backward.3ada8782.svg";